var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"body"},[_c('el-card',_vm._l((_vm.imageList),function(item,index){return _c('div',{key:index,staticClass:"image-container"},[_c('el-image',{staticClass:"el-image",attrs:{"src":item.name,"fit":"fill"}})],1)}),0)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }